export default "__VITE_ASSET__CPpc_4UY__"